'use client';

import { ChakraProvider } from '@chakra-ui/react';
import { ColorModeProvider } from './color-mode';
import { type ThemeProviderProps } from 'next-themes';
import { useWorkspaceTheme } from '@/lib/theme';

export function Provider(props: ThemeProviderProps) {
  const system = useWorkspaceTheme();

  return (
    <ChakraProvider value={system}>
      <ColorModeProvider {...props} />
    </ChakraProvider>
  );
}
